import { ISingleSubscription } from '../../../models/subscriptions/single_subscription.model';
import { ISubscriptions } from '../../../models/subscriptions/subscriptions.model';
import { ISubscriptionState } from './state.interface';

export const subscriptionState: ISubscriptionState = {
    allSubscriptions: {} as ISubscriptions,
    buttonLoading: false,
    loading: false,
    error: false,
    errorMessage: null,
    singleSubscription: {} as ISingleSubscription,
    cancelledSubscription: null,
    cancellingSubscription: false,
    errorCancelling: null,
    isSubCancellingFailed: false,
    isSubCancellingSuccess: false
};
